/* eslint-disable import/no-import-module-exports */
import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import rootReducer from '../reducers'

const configureAppStore = preloadedState => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: {
          ignoredPaths: ['form'],
        },
      }).concat(thunk),
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production',
  })

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      /* eslint-disable */
      const nextRootReducer = require('../reducers').default
      /* eslint-enable */
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}

export default configureAppStore
